// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__ou2vs","label":"Cell_label__3acJ2","action":"Cell_action__2NqkF"};